import { defaultVariant } from "../default";
import { OnboardingVariantType } from "../types";

// Same screens as the default variant; only the copy changes, through
// `onboarding.variants.improvedVerbiage` in native.json.
export const improvedVerbiageVariant: OnboardingVariantType = {
  steps: defaultVariant.steps,
};
